@if (isInitialized) {
  <oe-flat-widget [title]="'GENERAL.AUTARCHY' | translate" [icon]="{name: 'oe-grid', color:'normal'}" button
    [modalComponent]="modalComponent">
    <oe-flat-widget-percentagebar [value]="this.percentageValue">
    </oe-flat-widget-percentagebar>
  </oe-flat-widget>
}